// import React, { useState, useEffect, useRef } from "react";
// import "../../Landing.css";
// import "./ItemPathFilter.css";
// import { useSelector } from "react-redux";
// import { Link } from "react-router-dom";
// import GoldenSearch from "../../../../Assets/Images/CommanImages/golden-filter.png";
// import LinkIcon from "./../../../../Assets/Images/CommanImages/Vector.png";
// const MenuItem = ({ item, searchTerm, onClick, setPagePath }) => {
//   const itemName = item.name.toLowerCase();
//   const searchTermLower = searchTerm.toLowerCase();
//   const isMatch = itemName.includes(searchTermLower);

//   if (!isMatch) {
//     return null;
//   }

//   return (
//     <div className="ipf-menu-item" onClick={onClick}>
//       <div className="menu-item-content">
//         <Link to={item.ui_path} style={{ color: "black" }} onClick={() => setPagePath(item.path)}>
//           <div>
//             <img className="ipf-itemimage" src={LinkIcon} alt="" />
//             <strong className="ipf-itemfilter">{item.name}</strong>
//           </div>
//           <div className="ipf-menu-item-path">{item.path}</div>
//         </Link>
//       </div>
//     </div>
//   );
// };

// // const Menu = ({ data, searchTerm, onItemClick, setPagePath }) => {
// //   if (!searchTerm) {
// //     return null;
// //   }

// //   return (
// //     <div className="ipf-menu-container">
// //       {data
// //         .filter((item) =>
// //           item.name.toLowerCase().includes(searchTerm.toLowerCase())
// //         )
// //         .map((menuItem, index) => (
// //           <MenuItem
// //             key={index}
// //             item={menuItem}
// //             searchTerm={searchTerm}
// //             onClick={onItemClick}
// //             setPagePath={setPagePath}
// //           />
// //         ))}
// //     </div>
// //   );
// // };

// const Menu = ({ data, searchTerm, onItemClick, setPagePath }) => {
//   if (!searchTerm) {
//     return null;
//   }

//   const filteredItems = data.filter((item) =>
//     item.name.toLowerCase().includes(searchTerm.toLowerCase())
//   );

//   if (filteredItems.length === 0) {
//     return (
//       <div className="ipf-menu-container">
//         <div className="no-results">No results found</div>
//       </div>
//     );
//   }

//   return (
//     <div className="ipf-menu-container">
//       {filteredItems.map((menuItem, index) => (
//         <MenuItem
//           key={index}
//           item={menuItem}
//           searchTerm={searchTerm}
//           onClick={onItemClick}
//           setPagePath={setPagePath}
//         />
//       ))}
//     </div>
//   );
// };


// const SearchBar = ({ setSearchTerm, toggleDropdown }) => {
//   const handleChange = (value) => {
//     setSearchTerm(value);
//     toggleDropdown(true);
//   };

//   return (
//     <div className="input_wrapper">
//       <input
//         className="filter_input"
//         placeholder="Filter Menu"
//         onChange={(e) => handleChange(e.target.value)}
//         onFocus={() => toggleDropdown(true)}
//         style={{paddingLeft:"50px", fontWeight:"600", fontStyle:"italic"}}
//       />
//       {/* <p className="filter_icon"></p> */}
//       <img src={GoldenSearch} className="golden-filter" alt="" />
//     </div>
//   );
// };

// const getMenuStructureWithColors = (data) => {
//   const menuMap = {};
//   const menuStructure = [];
//   let localRoutes = [];

//   data.forEach((menuItem) => {
//     if (!menuMap[menuItem.LVL1]) {
//       menuMap[menuItem.LVL1] = {
//         name: menuItem.LVL1,
//         colors: "#ecf0f1",
//         children: [],
//       };
//       menuStructure.push(menuMap[menuItem.LVL1]);
//     }

//     let level2 = menuMap[menuItem.LVL1].children.find(
//       (c) => c.name === menuItem.LVL2
//     );
//     if (!level2) {
//       level2 = {
//         name: menuItem.LVL2,
//         colors: "#bdc3c7",
//         children: [],
//       };
//       menuMap[menuItem.LVL1].children.push(level2);
//     }

//     let level3 = level2.children.find((c) => c.name === menuItem.LVL3);
//     if (!level3) {
//       level3 = {
//         name: menuItem.LVL3,
//         colors: "#95a5a6",
//       };
//       level2.children.push(level3);
//     }

//     if (menuItem.ui_path && menuItem.ui_element) {
//       const routeExists = localRoutes.some(
//         (route) =>
//           route.ui_path === menuItem.ui_path &&
//           route.ui_element === menuItem.ui_element
//       );
//       if (!routeExists) {
//         localRoutes.push({
//           ui_path: menuItem.ui_path,
//           ui_element: menuItem.ui_element,
//         });
//       }
//       level3.ui_path = menuItem.ui_path;
//       level3.ui_element = menuItem.ui_element;
//     }
//   });

//   return { menuStructure, localRoutes };
// };

// const getLeafNodesWithPath = (menuStructure) => {
//   const leafNodes = [];

//   const traverse = (node, path) => {
//     if (!node.children || node.children.length === 0) {
//       if (node.ui_path && node.ui_element) {
//         leafNodes.push({
//           name: node.name,
//           ui_path: node.ui_path,
//           ui_element: node.ui_element,
//           path: `${path} > ${node.name}`,
//         });
//       }
//       return;
//     }

//     const currentPath = path ? `${path} > ${node.name}` : node.name;
//     node.children.forEach((child) => traverse(child, currentPath));
//   };

//   menuStructure.forEach((item) => traverse(item, ""));
//   return leafNodes;
// };

// function ItemPathFilter({ setPagePath }) {
//   const [menuData, setMenuData] = useState([]);
//   const { data } = useSelector((state) => state.landing);
//   let menuDatas = data && data.client_schema_name?.[2];

//   useEffect(() => {
//     if (menuDatas) {
//       setMenuData(menuDatas);
//     }
//   }, [menuDatas]);

//   const { menuStructure } = getMenuStructureWithColors(menuData);
//   const leafNodes = getLeafNodesWithPath(menuStructure);

//   const [searchTerm, setSearchTerm] = useState("");
//   const [showDropdown, setShowDropdown] = useState(false);
//   const dropdownRef = useRef(null);

//   const handleClickOutside = (event) => {
//     if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
//       setShowDropdown(false);
//     }
//   };

//   useEffect(() => {
//     document.addEventListener("mousedown", handleClickOutside);
//     return () => {
//       document.removeEventListener("mousedown", handleClickOutside);
//     };
//   }, []);

//   const handleItemClick = () => {
//     setSearchTerm("");
//     setShowDropdown(false);
//   };

//   return (
//     <div className="item-path-filter" ref={dropdownRef}>
//       <SearchBar
//         setSearchTerm={setSearchTerm}
//         toggleDropdown={setShowDropdown}
//       />
//       {showDropdown && (
//         <div className="ipf-dropdown-menu">
//           <Menu searchTerm={searchTerm} data={leafNodes} onItemClick={handleItemClick} setPagePath={setPagePath} />
//         </div>
//       )}
//     </div>
//   );
// }

// export default ItemPathFilter;



































import React, { useState, useEffect, useRef } from "react";
import "../../Landing.css";
import "./ItemPathFilter.css";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import GoldenSearch from "../../../../Assets/Images/CommanImages/golden-filter.png";
import LinkIcon from "./../../../../Assets/Images/CommanImages/Vector.png";
const MenuItem = ({ item, searchTerm, onClick, setPagePath }) => {
  const itemName = item.name.toLowerCase();
  const searchTermLower = searchTerm.toLowerCase();
  const isMatch = itemName.includes(searchTermLower);

  if (!isMatch) {
    return null;
  }

  return (
    <div className="ipf-menu-item" onClick={onClick}>
      <div className="menu-item-content">
        <Link to={item.ui_path} style={{ color: "black" }} onClick={() => setPagePath(item.path)}>
          <div>
            <img className="ipf-itemimage" src={LinkIcon} alt="" />
            <strong className="ipf-itemfilter">{item.name}</strong>
          </div>
          <div className="ipf-menu-item-path">{item.path}</div>
        </Link>
      </div>
    </div>
  );
};

// const Menu = ({ data, searchTerm, onItemClick, setPagePath }) => {
//   if (!searchTerm) {
//     return null;
//   }

//   return (
//     <div className="ipf-menu-container">
//       {data
//         .filter((item) =>
//           item.name.toLowerCase().includes(searchTerm.toLowerCase())
//         )
//         .map((menuItem, index) => (
//           <MenuItem
//             key={index}
//             item={menuItem}
//             searchTerm={searchTerm}
//             onClick={onItemClick}
//             setPagePath={setPagePath}
//           />
//         ))}
//     </div>
//   );
// };

const Menu = ({ data, searchTerm, onItemClick, setPagePath }) => {
  if (!searchTerm) {
    return null;
  }

  const filteredItems = data.filter((item) =>
    item.name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  if (filteredItems.length === 0) {
    return (
      <div className="ipf-menu-container">
        <div className="no-results">No results found</div>
      </div>
    );
  }

  return (
    <div className="ipf-menu-container">
      {filteredItems.map((menuItem, index) => (
        <MenuItem
          key={index}
          item={menuItem}
          searchTerm={searchTerm}
          onClick={onItemClick}
          setPagePath={setPagePath}
        />
      ))}
    </div>
  );
};


const SearchBar = ({ searchTerm, setSearchTerm, toggleDropdown }) => {
  const handleChange = (value) => {
    setSearchTerm(value);
    toggleDropdown(true);
  };

  return (
    <div className="input_wrapper">
      <input
        className="filter_input"
        placeholder="Filter Menu"
        value={searchTerm}
        onChange={(e) => handleChange(e.target.value)}
        onFocus={() => toggleDropdown(true)}
        style={{paddingLeft:"50px", fontWeight:"600", fontStyle:"italic"}}
      />
      {/* <p className="filter_icon"></p> */}
      <img src={GoldenSearch} className="golden-filter" alt="" />
    </div>
  );
};

const getMenuStructureWithColors = (data) => {
  const menuMap = {};
  const menuStructure = [];
  let localRoutes = [];

  data.forEach((menuItem) => {
    if (!menuMap[menuItem.LVL1]) {
      menuMap[menuItem.LVL1] = {
        name: menuItem.LVL1,
        colors: "#ecf0f1",
        children: [],
      };
      menuStructure.push(menuMap[menuItem.LVL1]);
    }

    let level2 = menuMap[menuItem.LVL1].children.find(
      (c) => c.name === menuItem.LVL2
    );
    if (!level2) {
      level2 = {
        name: menuItem.LVL2,
        colors: "#bdc3c7",
        children: [],
      };
      menuMap[menuItem.LVL1].children.push(level2);
    }

    if (menuItem.LVL3 === "") {
      // This is a 2nd-level leaf — the page lives at LVL2, no LVL3.
      // Store ui_path/ui_element directly on level2 so getLeafNodesWithPath
      // picks it up by its LVL2 name (e.g. "Question Paper Dashboard").
      if (menuItem.ui_path && menuItem.ui_element) {
        const routeExists = localRoutes.some(
          (route) =>
            route.ui_path === menuItem.ui_path &&
            route.ui_element === menuItem.ui_element
        );
        if (!routeExists) {
          localRoutes.push({
            ui_path: menuItem.ui_path,
            ui_element: menuItem.ui_element,
          });
        }
        level2.ui_path = menuItem.ui_path;
        level2.ui_element = menuItem.ui_element;
      }
    } else {
      let level3 = level2.children.find((c) => c.name === menuItem.LVL3);
      if (!level3) {
        level3 = {
          name: menuItem.LVL3,
          colors: "#95a5a6",
        };
        level2.children.push(level3);
      }

      if (menuItem.ui_path && menuItem.ui_element) {
        const routeExists = localRoutes.some(
          (route) =>
            route.ui_path === menuItem.ui_path &&
            route.ui_element === menuItem.ui_element
        );
        if (!routeExists) {
          localRoutes.push({
            ui_path: menuItem.ui_path,
            ui_element: menuItem.ui_element,
          });
        }
        level3.ui_path = menuItem.ui_path;
        level3.ui_element = menuItem.ui_element;
      }
    }
  });

  return { menuStructure, localRoutes };
};

const getLeafNodesWithPath = (menuStructure) => {
  const leafNodes = [];

  const traverse = (node, path) => {
    if (!node.children || node.children.length === 0) {
      if (node.ui_path && node.ui_element) {
        leafNodes.push({
          name: node.name,
          ui_path: node.ui_path,
          ui_element: node.ui_element,
          path: `${path} > ${node.name}`,
        });
      }
      return;
    }

    const currentPath = path ? `${path} > ${node.name}` : node.name;
    node.children.forEach((child) => traverse(child, currentPath));
  };

  menuStructure.forEach((item) => traverse(item, ""));
  return leafNodes;
};

function ItemPathFilter({ setPagePath }) {
  const [menuData, setMenuData] = useState([]);
  const { data } = useSelector((state) => state.landing);
  let menuDatas = data && data.client_schema_name?.[2];

  useEffect(() => {
    if (menuDatas) {
      setMenuData(menuDatas);
    }
  }, [menuDatas]);

  const { menuStructure } = getMenuStructureWithColors(menuData);
  const leafNodes = getLeafNodesWithPath(menuStructure);

  const [searchTerm, setSearchTerm] = useState("");
  const [showDropdown, setShowDropdown] = useState(false);
  const dropdownRef = useRef(null);

  const handleClickOutside = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setShowDropdown(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleItemClick = () => {
    setSearchTerm("");
    setShowDropdown(false);
  };

  return (
    <div className="item-path-filter" ref={dropdownRef}>
      <SearchBar
        searchTerm={searchTerm}
        setSearchTerm={setSearchTerm}
        toggleDropdown={setShowDropdown}
      />
      {showDropdown && (
        <div className="ipf-dropdown-menu">
          <Menu searchTerm={searchTerm} data={leafNodes} onItemClick={handleItemClick} setPagePath={setPagePath} />
        </div>
      )}
    </div>
  );
}

export default ItemPathFilter;

